var a = /* @__PURE__ */ ((r) => (r.rebu = "huspy-rebu", r.mortgage = "mortgage", r.bayteca = "bayteca", r))(a || {}), t = /* @__PURE__ */ ((r) => (r.dark = "dark", r.light = "light", r))(t || {});
export {
  t as Modes,
  a as Themes
};
